
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/share",
      function () {
        return require("private-next-pages/share/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/share"])
      });
    }
  